var forge = require('node-forge');
var hex64 = require('hex64');

forge.options.usePureJavaScript = true;



var hexChar = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];


const byteToHex = (b) => hexChar[(b >> 4) & 0x0f] + hexChar[b & 0x0f];

const bytesToHex = (b) => {
    var res = "";
    for (var i = 0; i < b.length; i++)
    {
        res += byteToHex(b.charCodeAt(i));
    }
    return res;
}

const hexToBytes = (hex) => {
  for (var bytes = [], c = 0; c < hex.length; c += 2)
      bytes.push(parseInt(hex.substr(c, 2), 16));
  return bytes;
}

const xor = (b1, b2) => {
  var b3 = [];
  var b4 = "";
  for (var i = 0; i < b1.length; i++)
  {
      var c = b1.charCodeAt(i) & 0xFF;
      var xored = c ^ b2[i];
      b3.push(xored);
      b4 += String.fromCharCode(xored);
  }
  return b4;
}

const doRSA = (data, pubkey) => {
  var publicKey = forge.pki.publicKeyFromPem(pubkey);
  var encrypted = publicKey.encrypt(data, 'RSAES-PKCS1-V1_5');
  return encrypted;
}


const genpbkd = (params) => {

    var salth = hex64.toHex(params.salt);
    var pubkey = params.pubkey; // tu ide transport key              
    var transid = hexToBytes(hex64.toHex(params.transid));
    var algver =  params.algver;
    var salt = '';

    if (algver === null) {
        algver = '1';
    }
    
    if (algver === '1'){
        salt = hexToBytes(salth);
    }
    if (algver === '2') {
        salt = forge.util.hexToBytes(salth);
    }

    var numIterations = 1000;
    var pbkdkey = forge.pkcs5.pbkdf2(params.pass, salt, numIterations, 16);

    var sad = xor(pbkdkey, transid);
    var enckey = doRSA(sad, pubkey);
    var keyhex = bytesToHex(enckey);
    
    return keyhex;
}

const addSignedHashToDocuments = (signedDocs, docs) => {
  return docs.map(doc => {
    let foundSignedDoc = signedDocs.find(signedDoc => doc.verificationCode === signedDoc.verificationCode)
    if (foundSignedDoc) {
      doc.signedHash = hex64.toHex(foundSignedDoc.signedHash)
      doc.timeStamp = foundSignedDoc.timeStamp
    }
    return doc
  })
}

const convertBase64ToHex = (base64) => {
  return hex64.toHex(base64)
}

const utils = {
  genpbkd,
  addSignedHashToDocuments,
  convertBase64ToHex
}

export default utils;